import {
  Checkbox,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import React from "react";
// import Rectangle73 from "assets/images/pricing/Rectangle73.png";
import Rectangle73 from "assets/images/pricing/Rectangle73New.png";

import Check from "assets/images/pricing/Check.png";
import Cross from "assets/images/pricing/Cross.png";

import MDButton from "components/MDButton";
import { Container } from "@mui/material";
import DemoRequestForm from "./components/DemoRequestForm";
import Header from "./components/header";
import Footer from "./components/footer.js";

import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ClearIcon from "@mui/icons-material/Clear";
import { NavLink } from "react-router-dom";
import { Helmet } from "react-helmet-async";
const Pricing = () => {
  const data = [
    {
      name: "Review Intelligence",
      check1: <CheckCircleIcon sx={{ color: "#21BA02", fontSize: "40" }} />,
      check2: <CheckCircleIcon sx={{ color: "#21BA02", fontSize: "40" }} />,
      check3: <CheckCircleIcon sx={{ color: "#21BA02", fontSize: "40" }} />,
    },
    {
      name: "Growth Intelligence",
      check1: <CheckCircleIcon sx={{ color: "#21BA02", fontSize: "40" }} />,
      check2: <CheckCircleIcon sx={{ color: "#21BA02", fontSize: "40" }} />,
      check3: <CheckCircleIcon sx={{ color: "#21BA02", fontSize: "40" }} />,
    },
    {
      name: "Local Intelligence",
      check1: <ClearIcon sx={{ color: "#F92F60", fontSize: "40" }} />,
      check2: <CheckCircleIcon sx={{ color: "#21BA02", fontSize: "40" }} />,
      check3: <CheckCircleIcon sx={{ color: "#21BA02", fontSize: "40" }} />,
    },
    {
      name: "Tavlo IQ",
      check1: <ClearIcon sx={{ color: "#F92F60", fontSize: "40" }} />,
      check2: <ClearIcon sx={{ color: "#F92F60", fontSize: "40" }} />,
      check3: <CheckCircleIcon sx={{ color: "#21BA02", fontSize: "40" }} />,
    },
    {
      name: "Add a 2nd business",
      content1: "+$70",
      content2: "+$50",
      content3: "+$30",
    },
    {
      name: "Add a 3rd business",
      content1: "+$60",
      content2: "+$40",
      content3: "+$20",
    },
    { name: "Add more businesses", content2: "Talk to sales" },
  ];
  return (
    <MDBox
      sx={{
        width: "100%",
        maxWidth: {
          xs: "100%",
          md: "1580px",
          xl: "1920px",
        },
        mx: "auto",
        // px: 2,
      }}
    >
      <Helmet>
        <title>
          {" "}
          TavloAI Pricing Page TavloAI Pricing Plans to Grow with Your
          Restaurant
        </title>
        <meta
          name="description"
          content="Discover TavloAI’s flexible pricing plans. Get the right AI platform for your restaurant, cafe, or bar to grow faster, improve reviews, and boost loyalty."
        />
        <meta name="keywords" content="Pricing Plans" />
      </Helmet>
      <Header></Header>
      <MDBox
        sx={{
          py: 3,
          mt: { xs: 7, sm: 4, md: 16 },
          mb: 6,
          zIndex: 4,
          backgroundColor: "#fff",
        }}
      >
        <MDBox
          sx={{ width: { xs: "100%", sm: "86%", md: "86%" }, margin: "auto" }}
        >
          <Grid container spacing={4} alignItems="center">
            {/* Left Side: Heading + Description */}
            <Grid item xs={6} md={6}>
              <MDBox
                sx={{
                  width: {
                    xs: "100%",
                    sm: "80%",
                  },
                  ml: {
                    xs: "20px",
                    sm: "99px",
                    md: "99px",
                  },
                  textAlign: "start",
                }}
              >
                <MDBox
                  variant="h2"
                  sx={{
                    fontWeight: "700",
                    fontFamily: "Poppins",
                    color: "#318BEC",
                    fontSize: { xs: "15px", sm: "30px", md: "40px" },
                    lineHeight: 1.3,
                    mt: { xs: 0, sm: -3, md: -3 },
                  }}
                >
                  Flexible Plans for Every Stage
                </MDBox>
                <MDTypography
                  variant="body1"
                  sx={{
                    mt: { xs: 0.5, sm: 2, md: 2 },
                    fontSize: { xs: "12px", sm: "18px", md: "18px" },
                    fontWeight: 400,
                    fontFamily: "Poppins",
                    lineHeight: { xs: "18px", sm: 1.3, md: 1.3 },

                    color: "#000",
                  }}
                >
                  Whether you're just starting out or scaling up, Tavlo.AI has a
                  plan designed to grow with your business. No hidden fees, just
                  real results.
                </MDTypography>
              </MDBox>
            </Grid>

            {/* Right Side: Image */}
            <Grid
              item
              xs={6}
              md={6}
              sx={{
                mr: {
                  xs: "0px",
                  sm: "0px",
                  md: "0px",
                },
              }}
            >
              <MDBox
                component="img"
                src={Rectangle73}
                alt="AI dashboard"
                objectFit="contain"
                sx={{
                  // ml: -4,
                  // width: "850px",
                  width: {
                    xs: "204px",
                    sm: "383px",
                    md: "550px",
                  },
                  //   height: "413px",
                  height: {
                    xs: "149px",
                    sm: "383px",
                    md: "393px",
                  },
                  borderRadius: {
                    xs: "5px",
                    sm: "16px",
                    md: "16px",
                  },
                  ml: {
                    xs: "-5px",
                    sm: "0px",
                    md: "0px",
                  },
                  boxShadow: "3px 5px 10px 3px #00000066",
                }}
              />
            </Grid>
          </Grid>
        </MDBox>
      </MDBox>

      <MDBox
      // sx={{ width: "90.5%", ml: "auto", mr: "44px" }}
      // sx={{ "@media (min-width:1580px)": { maxWidth: "1600px!important" } }}
      >
        <MDBox
          sx={{
            my: {
              xs: 4,
              sm: 3,
              md: 3,
            },

            width: {
              xs: "95%",
              sm: "83%",
            },
            m: "auto",
            px: {
              xs: 0,
              sm: 10,
              md: 10,
            },
          }}
        >
          <TableContainer
            component={Paper}
            elevation={3}
            sx={{
              width: {
                xs: "100%",
                sm: "100%",
                md: "100%",
              },

              // boxShadow: "3px 3px 10px 0px #49A3F140",
              borderRadius: {
                xs: "8px",
                sm: "15px",
                md: "15px",
              },
            }}
          >
            <Table>
              <TableRow sx={{ background: "#318BEC" }}>
                <TableCell
                  sx={{
                    width: { xs: "70%", sm: "30%", md: "30%" },
                    fontWeight: 600,
                    fontSize: { xs: "14px", sm: "22px", md: "22px" },
                    fontFamily: "Poppins",
                    color: "#fff",
                    px: { xs: "30px", sm: "25px" },
                    py: { xs: "5px", sm: 3.9, md: 3.9 },
                    // textAlign:{xs:"center"}
                    // border: "0.5px solid #8d8b8bff",
                  }}
                >
                  Services
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    width: { xs: "10%", sm: "23.3%" },
                    fontWeight: 600,
                    fontSize: { xs: "13.5px", sm: "22px", md: "26px" },

                    // fontSize: "26px",
                    lineHeight: 1.2,
                    fontFamily: "Poppins",
                    color: "#fff",
                    // border: "0.5px solid #8d8b8bff",
                  }}
                >
                  $129 <br></br>
                  <MDBox
                    sx={{
                      color: "#fff",
                      fontSize: { xs: "11.5px", sm: "19px", md: "19px" },
                      fontFamily: "Poppins",
                      fontWeight: 300,
                      lineHeight: 1,
                    }}
                  >
                    Standard
                  </MDBox>
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    width: { xs: "10%", sm: "23.3%" },
                    fontWeight: 600,
                    fontSize: { xs: "13.5px", sm: "22px", md: "26px" },
                    lineHeight: 1.2,
                    fontFamily: "Poppins",
                    color: "#fff",
                    // border: "0.5px solid #8d8b8bff",
                  }}
                >
                  $149 <br></br>
                  <MDBox
                    sx={{
                      color: "#fff",
                      fontSize: { xs: "11.5px", sm: "19px", md: "19px" },

                      fontFamily: "Poppins",
                      fontWeight: 300,
                    }}
                  >
                    Pro
                  </MDBox>
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    // border: "0.5px solid #8d8b8bff",
                    width: { xs: "10%", sm: "23.3%" },
                    fontWeight: 600,
                    fontSize: { xs: "13.5px", sm: "22px", md: "26px" },
                    lineHeight: 1.2,
                    fontFamily: "Poppins",
                    color: "#fff",
                  }}
                >
                  $169 <br></br>
                  <MDBox
                    sx={{
                      color: "#fff",
                      fontSize: { xs: "11.5px", sm: "19px", md: "19px" },

                      fontFamily: "Poppins",
                      fontWeight: 300,
                    }}
                  >
                    Expert
                  </MDBox>
                </TableCell>
              </TableRow>
              <TableBody>
                {data.map((row, idx) => {
                  const isLast = idx === data.length - 1;
                  return (
                    <TableRow
                      key={idx}
                      sx={{
                        backgroundColor: idx % 2 === 0 ? "#C8E2FF" : "#FFFFFF",
                      }}
                    >
                      <TableCell
                        sx={{
                          // border: "0.5px solid #8d8b8bff",
                          px: { xs: "5px", sm: "25px" },
                          py: { xs: 0.5, sm: "25px", md: 1 },
                          lineHeight: 0.6,
                          width: { xs: "50%", sm: "30%" },
                          fontSize: { xs: "11.5px", sm: "19px", md: "19px" },
                          fontFamily: "Poppins",
                        }}
                      >
                        {row.name}
                      </TableCell>

                      {isLast ? (
                        <TableCell
                          colSpan={3}
                          sx={{
                            textDecoration: "underline",
                            textAlign: "center",
                            fontWeight: 600,
                            fontSize: { xs: "12px", sm: "19px", md: "19px" },
                            fontFamily: "Poppins",
                            color: "#000",
                            p: 1,
                          }}
                        >
                          <NavLink
                            to="/contact"
                            style={{
                              textDecoration: "none",
                              color: "#000",
                              fontWeight: 600,
                              fontSize: "inherit",
                              fontFamily: "inherit",
                            }}
                          >
                            {row.content1 ||
                              row.content2 ||
                              row.content3 ||
                              "-"}
                          </NavLink>
                        </TableCell>
                      ) : (
                        [1, 2, 3].map((col, colIdx) => {
                          const checkKey = `check${col}`;
                          const contentKey = `content${col}`;

                          return (
                            <TableCell
                              key={colIdx}
                              sx={{
                                // border: "0.5px solid #8d8b8bff",
                                lineHeight: 0.6,
                                textAlign: "center",
                                width: { xs: "20%", sm: "23.3%" },
                                p: 1,
                              }}
                            >
                              {row[checkKey] ? (
                                <MDBox
                                  sx={{
                                    fontSize: {
                                      xs: "18px",
                                      sm: "28px",
                                      md: "28px",
                                    },
                                    fontWeight: 600,
                                  }}
                                >
                                  {row[checkKey]}
                                </MDBox>
                              ) : (
                                <MDTypography
                                  variant="body2"
                                  sx={{
                                    fontFamily: "Poppins",
                                    fontSize: {
                                      xs: "12px",
                                      sm: "17px",
                                      md: "17px",
                                    },
                                    color: "#000",
                                    fontWeight: { xs: 400, sm: 600, md: 600 },
                                  }}
                                >
                                  {row[contentKey] || "-"}
                                </MDTypography>
                              )}
                            </TableCell>
                          );
                        })
                      )}
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </MDBox>
      </MDBox>

      <Grid container>
        <Grid
          item
          lg={12}
          sx={{
            background:
              "linear-gradient(180deg, rgba(255, 255, 255, 0.6) 0%, rgba(49, 139, 236, 0.6) 100%)",
            py: { xs: 2, sm: 4, md: 12 },
            width: {
              xs: "100%",
              sm: "90%",
              md: "auto",
            },
            pb: {
              xs: 6,
              sm: 4,
              md: 6,
            },
          }}
        >
          <DemoRequestForm />
        </Grid>
      </Grid>
      <Footer></Footer>
    </MDBox>
  );
};

export default Pricing;
